import React from 'react';
import { OtherDetails } from 'components/Form/meter_details/other/OtherDetails';
import { OtherMeterDetailField } from 'components/Form/meter_details/other/constants';
import { MeterDetailOther } from '@enmon/commons/lib/enmon';

export const OtherAdditionalFields: React.VFC<MeterDetailOther> = ({ deviceCategory }) => (
  <OtherDetails
    itemsConfig={{
      [OtherMeterDetailField.DeviceCategory]: {
        formItemProps: { initialValue: deviceCategory },
      },
    }}
  />
);
